module.exports = __webpack_public_path__ + "img/7right-n-dcac4b62.png";